// DEPENDENCIES
import ShippingDefinitions from "commons/js/ShippingDefinitions";

// CONSTANTS
const MAP_LINK_CONTENT = {
  href: 'https://melhorenvio.com.br/mapa',
  text: 'Clique aqui'
};

const LATAM_LINK_CONTENT = {
  href: 'https://menv.io/como-transportar-pela-latam-cargo-com-o-melhor-envio',
  text: 'Saiba mais.'
};

const COMMON_CONTENT = {
  ticketData: 'É importante confirmar que todos os dados da etiqueta estão corretos antes de prosseguir para a impressão.',
  ticketRevocation: 'Caso você precise solicitar o cancelamento após gerar a etiqueta, o valor só será estornado corridas 12h da solicitação.',
  unitLocation: 'para consultar a localização da unidade que você selecionou para postar sua carga. 👉',
  mapLinkContent: MAP_LINK_CONTENT,
  latamLinkContent: LATAM_LINK_CONTENT
};

export function printAlertOrientations() {
  return {
    [ShippingDefinitions.CORREIOS_ID]: [
      { text: COMMON_CONTENT.ticketRevocation },
      COMMON_CONTENT.mapLinkContent,
      { text: 'para consultar a localização da agência dos Correios mais próxima de você para postar sua carga. 👉' },
      {
        href: 'https://menv.io/como-funcionam-os-fretes-dos-correios-pelo-melhor-envio',
        text: 'Saiba mais.'
      }
    ],
    [ShippingDefinitions.JADLOG_ID]: [
      { text: COMMON_CONTENT.ticketRevocation },
      COMMON_CONTENT.mapLinkContent,
      { text: COMMON_CONTENT.unitLocation },
      {
        href: 'https://menv.io/como-funciona-a-jadlog',
        text: 'Saiba mais.'
      }
    ],
    [ShippingDefinitions.LATAM_CARGO_ID]: (index) => {
      return [
        [
          COMMON_CONTENT.mapLinkContent,
          { text: COMMON_CONTENT.unitLocation },
          COMMON_CONTENT.latamLinkContent
        ],
        [
          {
            text: `Gerar a etiqueta significa solicitar a coleta, que é agendada para o endereço do remetente.
              Não é possível cancelar o envio após esta etapa. Se impressa até 6h da manhã de um dia útil, a coleta é agendada para o mesmo dia.
              Após esse horário (ou em dias não úteis), fica para o próximo dia. 👉`,
          },
          COMMON_CONTENT.latamLinkContent
        ]
      ][index]
    },
    [ShippingDefinitions.AZUL_CARGO_EXPRESS_ID]: [
      { text: `Leve sua carga até a unidade da Azul Cargo Express com as minutas e o documento (declaração de conteúdo ou DANFE) impressos.
          A embalagem deve estar aberta ou disponível para ser aberta, pois o conteúdo precisa ser conferido pela unidade.`
      },
      COMMON_CONTENT.mapLinkContent,
      { text: COMMON_CONTENT.unitLocation },
      {
        href: 'https://menv.io/como-funcionam-os-fretes-dos-correios-pelo-melhor-envio',
        text: 'Saiba mais.'
      }
    ],
    [ShippingDefinitions.BUSLOG_ID]: [
      { text: `${COMMON_CONTENT.ticketData} ${COMMON_CONTENT.ticketRevocation} 👉`
      },
      {
        href: 'https://menv.io/como-cancelar-etiquetas',
        text: 'Saiba mais.'
      }
    ],
    [ShippingDefinitions.LOGGI_ID]: [
      { text: COMMON_CONTENT.ticketRevocation },
      {
        href: 'https://menv.io/CentralDeAjudaLoggiColeta',
        text: 'Clique aqui'
      },
      { text: 'para conferir as regras de Coleta da Loggi. Para envios Express, confira o' },
      {
        ...COMMON_CONTENT.mapLinkContent,
        text: 'mapa de agências.'
      }
    ],
    [ShippingDefinitions.JET_ID]: [
      { text: `${COMMON_CONTENT.ticketData} ${COMMON_CONTENT.ticketRevocation} 👉`
      },
      {
        href: 'https://menv.io/como-cancelar-etiquetas',
        text: 'Saiba mais.'
      }
    ]
  }
}
